import React from 'react';

const QuotaStatusHeader = ({ userQuota, quotaStatus, quotaClasses, quotaInfo }) => {
  if (!userQuota || !quotaStatus) return null;

  return (
    <div className="d-flex justify-content-center justify-content-lg-end">
      <div className={`rounded-3 px-3 py-2 shadow-sm ${quotaClasses.bg} text-white`}>
        {/* Layout para desktop */}
        <div className="d-none d-md-flex align-items-center gap-3">
          <div className="text-center">
            <div className="d-flex align-items-center gap-2 mb-1">
              <i className={`bi ${quotaStatus.icon}`}></i>
              <span className="fw-semibold">{quotaStatus.label}</span>
            </div>
            <small className="opacity-75">Estado actual</small>
          </div>
          <div className="border-start border-white border-opacity-25 ps-3">
            <div className="text-center">
              <div className="h4 mb-0 fw-bold">
                {quotaInfo ? quotaInfo.available : '0'}
              </div>
              <small className="opacity-75">disponibles</small>
            </div>
          </div>
        </div>

        {/* Layout compacto para móvil */}
        <div className="d-md-none text-center">
          <div className="d-flex align-items-center justify-content-center gap-2 mb-1">
            <i className={`bi ${quotaStatus.icon}`}></i>
            <span className="fw-semibold small">{quotaStatus.label}</span>
          </div>
          <div className="d-flex align-items-center justify-content-center gap-2">
            <span className="h6 mb-0 fw-bold">
              {quotaInfo ? quotaInfo.available : '0'}
            </span>
            <small className="opacity-75">disponibles</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotaStatusHeader;
